import { Component, signal } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { HttpService } from 'src/app/services/http.service';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { Site } from '../../bo/site';
import { Tir } from '../../bo/tir';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-mes-tirs',
  templateUrl: './mes-tirs.component.html',
  styleUrls: ['./mes-tirs.component.scss'],
  standalone: false
})
export class MesTirsComponent {
  tabTirs = signal<Tir[]>([]);
  proprietesAfficheesTirs = signal<ProprieteAffichee[]>([]);
  siteId = signal<number>(0);
  erreurRecuperation = signal<boolean>(false);

  constructor(private readonly http: HttpService, private readonly utilService: UtilisateurService, private readonly route: ActivatedRoute, private readonly router: Router, private readonly fonctionsService: FonctionsService) {
    this.proprietesAfficheesTirs.set(new Tir().getProprietesAffichees());
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      var startLoader = setTimeout(() => {
        this.fonctionsService.loading_screen(true);
      }, 300);
      if (params.id == undefined) { //currentSite n'a pas encore été définit, cookie currentSite inexistant
        // this.http.get<Site[]>('Sites/Active').subscribe(res => {
        //   this.utilService.setCurrentSite(res[0]);
        //   this.router.navigate(['mysite', this.utilService.currentSite().siteId], { replaceUrl: true });
        // });
      } else {
        this.siteId.set(params.id);
        this.http.get<Tir[]>('Sites/' + this.siteId() + '/Blasts').subscribe(resultat => {
          this.tabTirs.set(resultat);
          this.fonctionsService.loading_screen(false);
          clearTimeout(startLoader);
        },(error:HttpErrorResponse) => {
          if(error.status === 401 || error.status === 403){
             console.log(error.error);
          }
          this.erreurRecuperation.set(true);
          this.fonctionsService.loading_screen(false);
          clearTimeout(startLoader);
        });
      }
    });
  }

  ouvrirTir(t: Tir) {
    const navigationExtras: NavigationExtras = {
      queryParams: { blastId: t.tirId },
      replaceUrl: true
    };
    this.router.navigate(['mysite', this.siteId(), 'myprojects', t.projetId], navigationExtras);
  }
}
